"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortenLookups = void 0;
const lodash_omitby_1 = __importDefault(require("lodash.omitby"));
const lodash_isnil_1 = __importDefault(require("lodash.isnil"));
exports.shortenLookups = {
    captureId: 'a',
    sessionId: 'b',
    tenantId: 'c',
    sessionCreated: 'd',
    ip: 'e',
    environment: 'f',
    dataResidency: 'g',
    spaceId: 'h',
    appId: 'i',
    appVersion: 'j',
    installationId: 'k',
    installationVersion: 'l',
    country: 'm',
    locationAccuracy: 'n',
    latitude: 'o',
    longitude: 'p',
    deviceId: 'q',
    clientId: 'r',
    eventType: 's',
    eventTime: 't',
    interaction: 'u',
    productId: 'v',
    categoryId: 'w',
    int1: 'x',
    int2: 'y',
    int3: 'z',
    int4: 'aa',
    int5: 'ab',
    str1: 'ac',
    str2: 'ad',
    str3: 'ae',
    str4: 'af',
    str5: 'ag',
    clientCreated: 'ah',
    clientIp: 'ai',
    clientUserAgent: 'aj',
    clientDeviceVendor: 'ak',
    clientDeviceModel: 'al',
    clientDeviceType: 'am',
    clientOsName: 'an',
    clientOsVersion: 'ao',
    clientBrowserName: 'ap',
    clientBrowserVersion: 'aq',
    clientBrowserMajor: 'ar',
    clientBrowserEngine: 'as',
    clientBrowserEngineVersion: 'at',
    clientCpuArchitecture: 'au',
    clientScreenWidth: 'av',
    clientScreenHeight: 'aw',
    clientScreenColorDepth: 'ax',
    clientScreenPixelDepth: 'ay',
    stateful: 'ba',
    public: 'bb',
};
function shortenKeys(obj) {
    const result = {};
    for (const key of Object.keys(obj)) {
        result[exports.shortenLookups[key]] = obj[key];
    }
    return lodash_omitby_1.default(result, lodash_isnil_1.default);
}
exports.default = shortenKeys;
